import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ArrowRight from '@wix/da-ds/pkg/Icons/16x16/ArrowRight';

import s from './FormStepsDisplay.scss';

interface Props {
  currentStep: number;
}

export const FormStepsDisplay: React.FC<Props> = ({ currentStep }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <div className={cn(s['step'], currentStep === 1 && s['current'])}>
        {t('customExclusivePopup.subheading.step1')}
      </div>
      <ArrowRight size={IconSize.SMALL} />
      <div className={cn(s['step'], currentStep === 2 && s['current'])}>
        {t('customExclusivePopup.subheading.step2')}
      </div>
    </div>
  );
};
FormStepsDisplay.displayName = 'FormStepsDisplay';

export default FormStepsDisplay;
